import * as React from 'react';
import { getAuthToken, isUserLoggedIn } from '@/redux/modules/user';
import { removeAuthCookie, setAuthCookie } from '@/redux/modules/cookies';
import { useDispatch, useSelector } from 'react-redux';
import usePrevious from '@/hooks/usePrevious';

const Auth = () => {
    const dispatch = useDispatch();
    const authToken = useSelector(getAuthToken);
    const userLoggedIn = useSelector(isUserLoggedIn);
    const prevAuthToken = usePrevious(authToken);
    const prevUserLoggedIn = usePrevious(userLoggedIn);

    const getExp = React.useCallback((token: string = '') => {
        const splitToken = token.split('.');
        if (splitToken.length < 2) {
            console.warn('Failed to decode JWT expiration');
            return;
        }
        try {
            if (!atob(splitToken[1])) {
                return;
            }
            const payload = JSON.parse(atob(splitToken[1]));
            return new Date(payload.exp * 1000);
        } catch (e) {
            console.warn('Failed to decode JWT expiration', e);
            return new Date(0);
        }
    }, []);

    React.useEffect(() => {
        if (authToken && authToken !== prevAuthToken) {
            const expires = getExp(authToken);
            dispatch(setAuthCookie(expires, authToken));
        } else if (prevUserLoggedIn && !userLoggedIn) {
            dispatch(removeAuthCookie());
        }
    }, [authToken, dispatch, getExp, prevAuthToken, prevUserLoggedIn, userLoggedIn]);

    return null;
};

export default Auth;
